import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
import { IconCellRenderer } from '@trueprodigy/components';
import AgGrid from '@components/AgGrid/AgGrid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import screenfull from 'screenfull';
import styled from 'styled-components';

import { withConfirm } from '../confirmationDialog';
import {
  Divider,
  HeaderContainer,
  Title,
  SearchTextField,
  FullScreenButton,
  AddCommentContainer,
  AddCommentTextField,
  AddButton,
  TableContainer,
} from '../tableStyledComponents';

class SubjectComments extends Component {
  static propTypes = {
    addNote: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    deleteNote: PropTypes.func.isRequired,
    notes: ImmutablePropTypes.map,
    subjectId: PropTypes.number.isRequired,
    subjectType: PropTypes.string.isRequired,
    updateNote: PropTypes.func.isRequired,
  };

  state = {
    newComment: '',
    screenMaximized: false,
  };

  getColumnDefs() {
    const { updateNote, deleteNote } = this.props;

    const columnDefs = [
      {
        headerName: 'Actions',
        field: 'actions',
        maxWidth: 140,
        width: 140,
        cellRenderer: IconCellRenderer,
        cellRendererParams: {
          icons: [
            {
              icon: updateNote && 'fa-edit',
              onClick: (val, data, api, rowIndex) => {
                api.startEditingCell({
                  colKey: 'content',
                  rowIndex,
                });
              },
            },
            {
              icon: deleteNote && 'fa-trash',
              onClick: (val, data) => {
                this.props.confirm({
                  title: 'Are you sure?',
                  description: 'The note will be permanently deleted.',
                  onConfirm: () => deleteNote({ noteID: data.id }),
                });
              },
            },
          ],
        },
      },
      { headerName: 'Date/Time', field: 'createdDt' },
      { headerName: 'User', field: 'createdBy' },
      { headerName: 'Comment', field: 'content', editable: true },
    ];
    return columnDefs;
  }

  maximizeWidget() {
    const el = document.getElementById('notesDisplay');
    screenfull.toggle(el);
    setTimeout(() => this.gridApi.sizeColumnsToFit(), 300);
  }

  searchChange(e) {
    const searchText = e.target.value;
    this.gridApi.setQuickFilter(searchText);
  }

  addNewComment() {
    const { addNote, subjectId } = this.props;
    const { newComment } = this.state;
    if (!newComment) {
      return;
    }

    addNote({
      id: subjectId,
      data: {
        content: newComment,
      },
    });
    this.setState({ newComment: '' });
  }

  updateNote(event) {
    const { data, oldValue, newValue } = event;
    if (oldValue !== newValue) {
      this.props.updateNote({
        noteId: data.id,
        data: {
          content: newValue,
          lastUpdate: data.updateDt,
        },
      });
    }
  }

  render() {
    const { notes, subjectType, addNote } = this.props;
    const notesJs = notes && notes.get('data') && notes.get('data').toJS();

    const rowData =
      notesJs &&
      notesJs.map(row => ({
        id: row.noteID,
        createdDt: row.createDt,
        createdBy: row.createdBy,
        updateDt: row.updateDt,
        content: row.content,
      }));
    const { newComment, screenMaximized } = this.state;
    return (
      <Container id="notesDisplay" screenMaximized={screenMaximized}>
        <Divider />
        <HeaderContainer>
          <Title>{subjectType.toUpperCase()} COMMENTS</Title>
          <SearchTextField
            label="Search Comments"
            style={{ marginRight: 9, height: 35 }}
            variant="outlined"
            onChange={this.searchChange.bind(this)}
          />
          <FullScreenButton onClick={this.maximizeWidget.bind(this)}>
            {screenMaximized ? <Fullscreen /> : <FullscreenExit />}
          </FullScreenButton>
        </HeaderContainer>
        <AddCommentContainer>
          <AddCommentTextField
            label={`Add an ${subjectType} Comment`}
            // ref={(input) => { this.commentInput = input; }}
            value={newComment}
            variant="outlined"
            onChange={e => this.setState({ newComment: e.target.value })}
          />
          <AddButton
            disabled={!addNote}
            size="small"
            onClick={() => this.addNewComment()}
          >
            Add
          </AddButton>
        </AddCommentContainer>
        <TableContainer className="ag-theme-material">
          <AgGrid
            columnDefs={this.getColumnDefs()}
            gridOptions={{
              editType: 'fullRow',
              onCellValueChanged: this.updateNote.bind(this),
            }}
            
            rowData={rowData}
            onGridReady={params => {
              this.gridApi = params.api;
              this.gridApi.sizeColumnsToFit();
            }}
          />
        </TableContainer>
      </Container>
    );
  }
}

const Container = styled.div`
  background-color: #fff;
`;

export default withConfirm(SubjectComments);
